import { render } from "./BudgetProcessItemForm.vue?vue&type=template&id=23a724c8&scoped=true"
import script from "./BudgetProcessItemForm.vue?vue&type=script&lang=js"
export * from "./BudgetProcessItemForm.vue?vue&type=script&lang=js"

import "./BudgetProcessItemForm.vue?vue&type=style&index=0&id=23a724c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a724c8"]])

export default __exports__